import profileService from "../../services/profile";


const profile = {
  namespaced: true,
  state: {
    info: null,
    contractInfo: null
  },
  actions: {
    getProfileInfo(store) {
      return new Promise((resolve, reject) => {
        profileService.getChargePlanning().then(res => {
          if (res.success) {
            store.commit('SET_PROFILE', res);
            resolve(res);
          } else {
            reject(res.message);
          }
        }).catch(err => {
          reject(err);
        });
      })
    },
    getContractInfo(store) {
      return new Promise((resolve, reject) => {
        profileService.getMyContract().then(res => {
          if (res.success) {
            store.commit('SET_CONTRACT', res.data);
            resolve(res.data);
          } else {
            reject(res.message);
          }
        }).catch(err => {
          reject(err);
        });
      })
    },
    submitContract(store, {idTypeLissageInfo, typeLissageInfo}) {
      return new Promise((resolve, reject) => {
        profileService.submitContract({idTypeLissageInfo, typeLissageInfo}).then(res => {
          if (res.success) {
            resolve(res);
          } else {
            reject(res);
          }
        }).catch(err => {
          reject(err);
        });
      })
    }
  },
  getters: {
    fullProfileInfo: (state) => state.info,
    profileInfo: (state) => {
      return state.info? state.info.data : null
    },
    contractInfo: (state) => state.contractInfo
  },
  mutations: {
    SET_PROFILE: (state, info) => {
      state.info = info;
    },
    SET_CONTRACT: (state, contract) => {
      state.contractInfo = contract;
    },
  }

};

export default profile;